import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import Sidebar from "./Home/Sidebar";
import { BannerAdd, HomeBanner, HomeBannerEdit } from "./Home/Banner";
import {
  EmergencyAdd,
  HomeEmergency,
  HomeEmergencyEdit,
  HomeOpeningHourEdit,
  HomeOpeningHourTopEdit,
} from "./Home/Emergancy";
import {
  HomeService,
  HomeServiceEdit,
  HomeServiceView,
  ServiceAdd,
  ServiceHeaderEdit,
} from "./Home/Service";
import {
  DentacareAdd,
  DentacareEdit,
  HomeDentacare,
  HomeDentacareImageEdit,
  HomeDentacareTopEdit,
} from "./Home/DentaCare";
import {
  HomeMeet,
  HomeMeetEdit,
  HomeMeetView,
  MeetAdd,
  MeetHeaderEdit,
} from "./Home/MeetDentist";
import {
  AchievementAdd,
  HomeAchievement,
  HomeAchievementEdit,
  HomeAchievementTopEdit,
} from "./Home/Achievement";
import {
  HomePrice,
  HomePriceEdit,
  HomePriceView,
  PriceAdd,
  PriceHeaderEdit,
} from "./Home/Price";
import { HomeNews, NewsAdd, NewsEdit } from "./Home/NewsLetter";
import {
  HomeTestimony,
  HomeTestimonyEdit,
  HomeTestimonyView,
  TestimonyAdd,
  TestimonyHeaderEdit,
} from "./Home/Testimony";
import {
  GalleryAdd,
  HomeGallery,
  HomeGalleryEdit,
  HomeGalleryView,
} from "./Home/Gallery";
import {
  BlogAdd,
  BlogHeaderEdit,
  HomeBlog,
  HomeBlogEdit,
  HomeBlogView,
} from "./Home/Blog";
import { HomeQuote, HomeQuoteEdit, QuoteAdd } from "./Home/Quote";
import { HomeQuoteForm } from "./Home/QuoteForm";
import { AboutAdd, HomeAbout, HomeAboutEdit } from "./About/About";
import {
  GalleryDataAdd,
  HomeGalleryData,
  HomeGalleryDataEdit,
  HomeGalleryDataView,
} from "./Gallery.js/GalleryData";
import { ContactEdit, ContactTopEdit, HomeContact } from "./Contact/Contact";
import { HomeContactForm } from "./Contact/ContactForm";
import {AppointmentForm} from "./Contact/AppointmentForm"
import { HomeAppointmentForm } from "./Home/HomeAppointmentForm";

function App() {
  return (
    <div>
      <Router>
        <Sidebar />
        <ToastContainer />
        <Routes>
          <Route exact path="/" element={<HomeBanner />} />
          <Route path="/banner-edit/:id" element={<HomeBannerEdit />} />
          <Route path="/banner-add" element={<BannerAdd />} />

          {/* emergency  */}
          <Route path="/Emergency" element={<HomeEmergency />} />
          <Route path="/Emergency-edit/:id" element={<HomeEmergencyEdit />} />
          <Route path="/Emergency-add" element={<EmergencyAdd />} />
          <Route
            path="/OpeningHour-top-edit/:id"
            element={<HomeOpeningHourTopEdit />}
          />
             <Route
            path="/OpeningHour-edit/:id"
            element={<HomeOpeningHourEdit />}
          />

          {/* Service   */}
          <Route path="/Service" element={<HomeService />} />
          <Route path="/Service-edit/:id" element={<HomeServiceEdit />} />
          <Route path="/Service-add" element={<ServiceAdd />} />
          <Route path="/Service-view/:id" element={<HomeServiceView />} />
          <Route
            path="/Service-header-edit/:id"
            element={<ServiceHeaderEdit />}
          />

          {/* Dentacare   */}
          <Route path="/Dentacare" element={<HomeDentacare />} />
          <Route path="/Dentacare-add" element={<DentacareAdd />} />
          <Route path="/Dentacare-edit/:id" element={<DentacareEdit />} />
          <Route
            path="/Dentacare-header-edit/:id"
            element={<HomeDentacareTopEdit />}
          />
           <Route path="/Dentacare-image-edit/:id" element={<HomeDentacareImageEdit />} />

          {/* Meet   */}
          <Route path="/Meet" element={<HomeMeet />} />
          <Route path="/Meet-edit/:id" element={<HomeMeetEdit />} />
          <Route path="/Meet-add" element={<MeetAdd />} />
          <Route path="/Meet-view/:id" element={<HomeMeetView />} />
          <Route path="/Meet-header-edit/:id" element={<MeetHeaderEdit />} />

          {/* Achievement  */}
          <Route path="/Achievement" element={<HomeAchievement />} />
          <Route
            path="/Achievement-edit/:id"
            element={<HomeAchievementEdit />}
          />
            <Route
            path="/Achievement-top-edit/:id"
            element={<HomeAchievementTopEdit />}
          />
          <Route path="/Achievement-add" element={<AchievementAdd />} />

          {/* Price   */}
          <Route path="/Price" element={<HomePrice />} />
          <Route path="/Price-edit/:id" element={<HomePriceEdit />} />
          <Route path="/Price-add" element={<PriceAdd />} />
          <Route path="/Price-view/:id" element={<HomePriceView />} />
          <Route path="/Price-header-edit/:id" element={<PriceHeaderEdit />} />

          {/* News   */}
          <Route path="/News" element={<HomeNews />} />
          <Route path="/News-edit/:id" element={<NewsEdit />} />
          <Route path="/News-add" element={<NewsAdd />} />

          {/* Testimony   */}
          <Route path="/Testimony" element={<HomeTestimony />} />
          <Route path="/Testimony-edit/:id" element={<HomeTestimonyEdit />} />
          <Route path="/Testimony-add" element={<TestimonyAdd />} />
          <Route path="/Testimony-view/:id" element={<HomeTestimonyView />} />
          <Route
            path="/Testimony-header-edit/:id"
            element={<TestimonyHeaderEdit />}
          />

          {/* Gallery   */}
          <Route path="/Gallery" element={<HomeGallery />} />
          <Route path="/Gallery-edit/:id" element={<HomeGalleryEdit />} />
          <Route path="/Gallery-add" element={<GalleryAdd />} />
          <Route path="/Gallery-view/:id" element={<HomeGalleryView />} />

          {/* Blog   */}
          <Route path="/Blog" element={<HomeBlog />} />
          <Route path="/Blog-edit/:id" element={<HomeBlogEdit />} />
          <Route path="/Blog-add" element={<BlogAdd />} />
          <Route path="/Blog-view/:id" element={<HomeBlogView />} />
          <Route path="/Blog-header-edit/:id" element={<BlogHeaderEdit />} />

          {/* Quote  */}
          <Route path="/Quote" element={<HomeQuote />} />
          <Route path="/Quote-edit/:id" element={<HomeQuoteEdit />} />
          <Route path="/Quote-add" element={<QuoteAdd />} />

          {/* QuoteForm  */}
          <Route path="/QuoteForm" element={<HomeQuoteForm />} />

          {/* About  */}
          <Route path="/About" element={<HomeAbout />} />
          <Route path="/About-edit/:id" element={<HomeAboutEdit />} />
          <Route path="/About-add" element={<AboutAdd />} />

          {/* GalleryData   */}
          <Route path="/GalleryData" element={<HomeGalleryData />} />
          <Route
            path="/GalleryData-edit/:id"
            element={<HomeGalleryDataEdit />}
          />
          <Route path="/GalleryData-add" element={<GalleryDataAdd />} />
          <Route
            path="/GalleryData-view/:id"
            element={<HomeGalleryDataView />}
          />

          {/* Contact   */}
          <Route path="/Contact" element={<HomeContact />} />
          <Route path="/Contact-edit/:id" element={<ContactEdit />} />
          <Route path="/Contact-top-edit/:id" element={<ContactTopEdit />} />

          {/* ContactForm  */}
          <Route path="/ContactForm" element={<HomeContactForm />} />

          {/* AppointmentForm  */}
          <Route path="/AppointmentForm" element={<AppointmentForm/>} />

           {/* Home AppointmentForm  */}
           <Route path="/HomeAppointmentForm" element={<HomeAppointmentForm/>} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
